export const RAPPROCHEMENT_ACHAT = {
  infoFacture: 'Information facture',
  rapprochement: 'Rapprochement',
  fournisseur: 'Fournisseur',
  montantHtAffecter: 'Montant HT à affecter',
  datePaiement: 'Date prev. de paiement',
  modeReglement: 'Mode de règlement',
  typeRapprochement: 'Type de rapprochement',
  rechercheBy: 'Rechercher par codes',
  periodeRecherche: 'Période de recherche',
  resteAffectation: 'Reste à affecter',
  affectation: 'Affectation',
  error: {
    moreAffectationThanBillAmont: 'Le montant du rapprochement est supérieur au montant de la facture',
    noCommandeAchatARapprocher: 'Vous n\'avez aucune commande d\'achat à rapprocher pour le fournisseur {fournisseur}',
    noCommandeAchatRapprocher: 'Vous n\'avez aucune commande d\'achat rapprochée pour le fournisseur {fournisseur}',
    needFournisseur: 'Vous devez ajouter un fournisseur à votre facture pour faire le rapprochement',
  },
  tab: {
    reference: 'Référence',
    dateEcheance: 'Date d’échéance',
    montantHt: 'Montant Ht',
    montantRestant: 'Montant restant',
    montantAAffecter: 'Montant à affecter',
    montantAffecter: 'Montant affecté',
    solde: 'Solde',
    dateDebut: 'Date début échéance',
    dateFin: 'Date fin échéance',
  },
  type: {
    bail: 'Bail',
    tlpe: 'Tlpe',
    achat: 'Achat',
  },
};

export const NOTHING = null;
